import { itemName } from '../../trace/ports.js';
import { defineRule } from '../rule.js';

/** What an item may hang on: mics/DIs on stands, lights on stands or trusses (OIL-15). */
const CARRIERS: Readonly<Record<string, readonly string[]>> = {
  light: ['stand', 'truss'],
};

/** E: an item is mounted on something that does not exist or cannot carry it. */
export const mountInvalid = defineRule(
  'mount-invalid',
  'error',
  { en: 'Mounted on a missing stand', de: 'Auf fehlendem Stativ montiert' },
  (data, emit) =>
    Object.values(data.items)
      .filter((i) => {
        if (i.mountedOn === undefined) return false;
        const carrier = data.items[i.mountedOn]?.kind;
        return carrier === undefined || !(CARRIERS[i.kind] ?? ['stand']).includes(carrier);
      })
      .map((i) => emit([i.id], { label: itemName(i) })),
);
